import React from 'react';

const AgendaFormFilterParticipation = ({OnChangeFilterParticipation}) => (
	<div className="generic-filters-select agenda-filters-select agenda-filters-participation" ><label className="switch"><span className="switch-text" >Gratuit</span><input type="checkbox" value="122" onChange={OnChangeFilterParticipation} /><span className="slider round"></span></label></div>
)

export default AgendaFormFilterParticipation;
